import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../../environments/environment';
import { ApiService } from '../../../../core/services/api.service';
import {
	ICompaniesCreatePayload,
	ICompaniesDetailResponse,
	ICompaniesListPayload,
	ICompaniesListResponse,
	ICompaniesMetadataResponse,
	ICompaniesUpdatePayload,
} from '../models/companies.models';

@Injectable({
	providedIn: 'root',
})
export class CompaniesService extends ApiService {
	public list(body: ICompaniesListPayload): Observable<ICompaniesListResponse> {
		return this.http.post<ICompaniesListResponse>(environment.apiUrl + `/companies`, body, {
			headers: this.getHeaders(),
		});
	}

	public create(body: ICompaniesCreatePayload): Observable<any> {
		return this.http.post<any>(environment.apiUrl + `/company/create`, body, {
			headers: this.getHeaders(),
		});
	}

	public update(uuid: string, body: ICompaniesUpdatePayload): Observable<any> {
		return this.http.patch<any>(environment.apiUrl + `/company/${uuid}`, body, {
			headers: this.getHeaders(),
		});
	}

	public detail(uuid: string): Observable<ICompaniesDetailResponse> {
		return this.http.get<ICompaniesDetailResponse>(environment.apiUrl + `/company/${uuid}`, {
			headers: this.getHeaders(),
		});
	}

	public delete(uuid: string): Observable<any> {
		return this.http.delete<any>(environment.apiUrl + `/company/${uuid}`, {
			headers: this.getHeaders(),
		});
	}

	public getMetadata(uuid: string): Observable<ICompaniesMetadataResponse> {
		return this.http.get<ICompaniesMetadataResponse>(environment.apiUrl + `/company/${uuid}/metadata`, {
			headers: this.getHeaders(),
		});
	}
}
